import { AdviseSupplierLineItem } from '../../../../types/advise';
import { SelectMenu } from '../../../Atoms/SelectMenu';
import { categoryOptions } from './InvoiceView.calc';

export interface LineCategoryProps {
  line: AdviseSupplierLineItem;
  label: string;
  categories: string[];
  canEdit: boolean;
  onCategoryChange: (category: string) => void;
}

/** A line's category: a dropdown of the engagement's price categories for an editor, plain text otherwise. */
export const LineCategory = ({ line, label, categories, canEdit, onCategoryChange }: LineCategoryProps) =>
  canEdit ? (
    <SelectMenu
      name={`category-${line.id}`}
      ariaLabel={`Category: ${label}`}
      value={line.category}
      selectClasses={line.in_scope ? '' : '!text-grey-4'}
      options={categoryOptions(categories, line.category).map((category) => ({ value: category, text: category }))}
      handleSelect={(event) => onCategoryChange(event.target.value)}
    />
  ) : (
    <>{line.category}</>
  );
